import script from "./ShopIntegrationSubsystemSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShopIntegrationSubsystemSettings.vue?vue&type=script&setup=true&lang=ts"

import "./ShopIntegrationSubsystemSettings.vue?vue&type=style&index=0&id=e0ad984c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0ad984c"]])

export default __exports__